module.exports = __webpack_public_path__ + "static/media/Dean-Mullins-10.25x10.eca112e9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ads/Dean-Mullins-10.25x10.jpg
// module id = 31
// module chunks = 0